import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import BulletList from 'Components/ComponentLibrary/Molecules/BulletList';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import { stepMap } from 'Views/Page/Content/Modal/Layouts/TotpRegistration/Layout';
import CenteredActions from 'Views/Page/Content/Modal/Components/CenteredActions';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';

const styles = (theme) => ({
  root: {},
  stepTitle: {
    paddingBottom: theme.spacing(2),
  },
});

const Intro = ({
  className,
  classes,
  changeState,
}) => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Typography
        variant={'h4'}
        weight={'bold'}
        className={classes.stepTitle}
      >
        {'Install an Authentication App'}
      </Typography>
      <BulletList
        listItems={[
          'On your iPhone or Android device, access the App Store or Google Play Store.',
          'Search for GOOGLE AUTHENTICATOR or AUTHY or similar authentication app.',
          'Tap the app and download to install it.',
        ]}
      />
      <CenteredActions>
        <RoundedButton
          fullWidth
          onClick={() => {
            logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Auth Factor Authenticator: Intro continue');
            changeState(stepMap.captureQRCode);
          }}
          test={'security-settings-button-authenticatorApp-register-modal-start'}
        >
          {'Continue'}
        </RoundedButton>
      </CenteredActions>
    </Box>
  );
};

Intro.defaultProps = {
  className: '',
};

Intro.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  changeState: PropTypes.func.isRequired,
};

export default withStyles(styles)(Intro);
